import { render, staticRenderFns } from "./ListaPrestadoresDownload.vue?vue&type=template&id=59d529a1&scoped=true"
import script from "./ListaPrestadoresDownload.vue?vue&type=script&lang=js"
export * from "./ListaPrestadoresDownload.vue?vue&type=script&lang=js"
import style0 from "./ListaPrestadoresDownload.vue?vue&type=style&index=0&id=59d529a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d529a1",
  null
  
)

export default component.exports